import React, { useRef, useState } from 'react';
import { TableInput } from '../../../../../components/common';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { Grid, MenuItem, Stack } from '@mui/material';
import CustomSelect from '../../../../../components/common/SelectField';
import {
  AddIconButton,
  CustomIconButton,
  DeleteIconButton,
  RemoveIconButton,
  UploadImageIconButton,
  ViewIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import Add from '@mui/icons-material/Add';
import { useAuth } from '../../../../../services/auth/AuthProvider';
import OperationSelect from '../OperationSelect';
import SimpleSelect from '../../../../../components/common/SimpleSelect';

interface IProps {
  moduleData: any;
  isView: boolean;
  process: any;
  index: number;
  handelDeleteRows: any;
  handleSumbit: any;
  uploadImageFile: any;
  setIsOpenPopup: any;
  setPartIdx: any;
}
const TBodyRow = ({
  isView,
  process,
  index,
  handelDeleteRows,
  handleSumbit,
  uploadImageFile,
  moduleData,
  setIsOpenPopup,
  setPartIdx,
}: IProps) => {
  const [render, setRender] = useState(false);
  const { state } = useAuth();
  return (
    <React.Fragment key={index + 10.1 + 'heading '}>
      <tr>
        <th style={{ minWidth: '50px', textAlign: 'center' }}>{index + 1}</th>
        {/* <td style={{ minWidth: '200px', textAlign: 'center' }}>
          <TableInput
            isView={isView}
            name="machine_name_and_location"
            type="text"
            value={process.machine_name_and_location}
            onChange={(e) => {
              handleChangeModuleData(e, process);
              setRender((prev) => !prev);
            }}
          />
        </td> */}
        <td style={{ width: '250px', minWidth: '250px' }}>
          {isView ? (
            process?.part_id && process?.part_id?.part_name
          ) : (
            <Grid container xs={12} direction="row" alignItems={'center'}>
              <Grid item xs={10}>
                <p
                  style={{
                    fontSize: '1.6rem',
                  }}
                >
                  {typeof process?.part_id === 'object' &&
                  process?.part_id !== null
                    ? process?.part_id?.part_name
                    : process?.partName || ''}
                  {!process?.part_id && 'Pick Part Name'}
                </p>
              </Grid>

              {process.part_id ? (
                <Grid item xs={2}>
                  <RemoveIconButton
                    tooltipTitle="remove part"
                    onClick={() => {
                      process.part_id = null;
                      process.partNumber = null;
                      process.partName = null;
                      setRender((prev) => !prev);
                    }}
                  />
                </Grid>
              ) : (
                <Grid item xs={2}>
                  <AddIconButton
                    tooltipTitle="add part"
                    onClick={() => {
                      setIsOpenPopup(true);
                      setPartIdx(index);
                    }}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </td>
        <td style={{ minWidth: '200px' }}>
          <OperationSelect
            {...{ process, isView, setRender }}
            partId={
              typeof process.part_id === 'string'
                ? process?.part_id
                : process?.part_id?._id
            }
          />
        </td>
        {/* <td style={{ minWidth: '200px', textAlign: 'center' }}>
          <TableInput
            isView={isView}
            name="method_of_verification"
            type="text"
            value={process.method_of_verification}
            onChange={(e) => {
              handleChangeModuleData(e, process);
              setRender((prev) => !prev);
            }}
          />
        </td> */}
        <td style={{ minWidth: '200px', textAlign: 'center' }}>
          <TableInput
            isView={isView}
            name="poke_yoke_name"
            type="text"
            value={process.poke_yoke_name}
            onChange={(e) => {
              handleChangeModuleData(e, process);
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td style={{ minWidth: '200px', textAlign: 'center' }}>
          {moduleData._id && (
            <Stack
              direction="row"
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <UploadImageIconButton
                id={`${index}-process-upload`}
                tooltipTitle="upload"
                sx={{}}
                onChange={(e) => {
                  uploadImageFile(e, index);
                }}
              />
              {process.files?.length > 0 ? (
                <>
                  <ViewIconButton
                    tooltipTitle="view image"
                    onClick={() => {
                      window.open(process.files[0].url, '_blank', 'noreferrer');
                    }}
                  />
                  <DeleteIconButton
                    tooltipTitle={'delete'}
                    onClick={() => {
                      if (
                        window.confirm(
                          'Are you sure u want to delete this image!!!',
                        )
                      ) {
                        setRender((prev) => !prev);
                        process.files = [];
                      }
                    }}
                  />
                </>
              ) : (
                <DeleteIconButton
                  sx={{
                    opacity: '0',
                    PointerEvent: 'none',
                    visibility: 'hidden',
                  }}
                  tooltipTitle=""
                />
              )}
            </Stack>
          )}
        </td>
        {Array.from({ length: 31 }, (_, dayIndex) => (
          // <td
          //   style={{
          //     minWidth: '100px',
          //     textAlign: 'center',
          //     fontSize: '2rem',
          //   }}
          //   key={index + 2.2 + indx + 'after' + 111.33}
          // >
          //   {isView ? (
          //     (process.results[indx] === 'true' && '✓') ||
          //     (process.results[indx] === 'false' && '⨯')
          //   ) : (
          //     <CustomSelect
          //       name="results[indx]"
          //       value={process.results[indx]}
          //       onChange={(e) => {
          //         process.results[indx] = e.target.value;
          //         setRender((prev) => !prev);
          //       }}
          //     >
          //       <MenuItem value="true">✓</MenuItem>
          //       <MenuItem value="false">⨯</MenuItem>
          //     </CustomSelect>
          //   )}
          // </td>
          <td
            style={{ minWidth: '70px', fontSize: '30px' }}
            key={dayIndex + 'dayIndex'}
          >
            {isView ? (
              process.results[dayIndex]
            ) : (
              <SimpleSelect
                name={`process.results[${dayIndex}]`}
                value={process.results[dayIndex]}
                onChange={(e: any) => {
                  process.results[dayIndex] = e.target.value;
                  setRender((prev) => !prev);
                }}
                values={[
                  { value: '', label: '' },
                  { value: '✓', label: '✓' },
                  { value: '⨯', label: '⨯' },
                ]}
                style={{
                  padding: '8px',
                  fontSize: '30px',
                  border: '3px solid white',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  outline: 'none',
                  width: '70px',
                  backgroundColor: 'white',
                  color: 'black',
                }}
                optionStyle={{
                  backgroundColor: 'white',
                  color: 'black',
                  width: '40px',
                }}
              />
            )}
          </td>
        ))}
        <td
          style={{ minWidth: '100px', textAlign: 'center' }}
          colSpan={isView ? 2 : 1}
        >
          <TableInput
            isView={isView}
            name="remarks"
            type="text"
            value={process.remarks}
            onChange={(e) => {
              handleChangeModuleData(e, process);
              setRender((prev) => !prev);
            }}
          />
        </td>
        {!isView && (
          <td style={{ minWidth: '100px', textAlign: 'center' }}>
            <DeleteIconButton
              tooltipTitle={'delete'}
              onClick={() => handelDeleteRows(index)}
            />
          </td>
        )}
      </tr>
    </React.Fragment>
  );
};

export default TBodyRow;
